<template>
  <div>
    <template v-if="this.type === 'forAcadmicYear' || this.type === 'forCurrentYear'">
      <div class="field">
        <label class="label">{{ label }} <span class="has-text-danger">*</span></label>
        <div class="control">
          <span class="select is-fullwidth">
            <select :name="label" v-model="acadmicID" :disabled="disabled" required v-on="$listeners" academicYears="academicYears" @change="onChangeInfo(acadmicID)"
              >/
              <option value>--Select--</option>
              <option :value="info.id ? info.id : info.name" v-for="info in dataInfo" :key="info.id"> {{ info[listName] && info[listName] }}</option>
            </select>
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <label class="label">{{ label }} <span class="has-text-danger">*</span></label>
      <v-autocomplete placeholder="--Select--" v-model="ExstID" v-on="$listeners" key="id" :items="dataInfo" :item-text="listName" item-value="id" :filter="customFilter" :disabled="disabled" :name="label" @change="onChangeInfo(ExstID)"
        required :hide-details="true" dense outlined :menu-props="{ maxHeight: '300px' }">
        <template v-slot:item="{ item }">
          ({{ item.id }}) {{ item[listName] }}
        </template>
        <template v-slot:selection="{ item }">
          ({{ item.id }}) {{ item[listName] }}
        </template>
      </v-autocomplete>
    </template>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import store from '@/store'
export default {
  props: ['type', 'disabled'],
  data () {
    return {
      dataInfo: [],
      label: '',
      listName: '',
      ExstID: '',
      acadmicID: '',
      loadingComponent: null
    }
  },

  computed: {
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    },
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    },
    moduleID: {
      get () {
        return store.state.feeComponent.moduleID
      },
      set (value) {
        store.commit('updateModuleID', value)
      }
    },
    categoryID: {
      get () {
        return store.state.feeComponent.categoryID
      },
      set (value) {
        store.commit('updatecategoryID', value)
      }
    }
  },

  async created () {
    if (this.type === 'forAcadmicYear') {
      this.apiName = 'franchiseeAcademicYears'
      this.label = 'Select Academic Year'
      await this.getData(this.apiName)

      this.listName = 'academicYear'
      this.acadmicID = this.academicYearID
    }
    if (this.type === 'forCurrentYear') {
      this.apiName = 'franchiseeAcademicYears?isCurrentAcademicYear=true'
      this.label = 'Select Academic Year'
      await this.getData(this.apiName)
      this.listName = 'academicYear'
      this.acadmicID = this.academicYearID
    }
    if (this.type === 'forFranchiseeSelection') {
      this.apiName = 'franchisee/active'
      this.label = 'Select Franchisee'
      await this.getData(this.apiName)
      this.listName = 'companyName'
      this.ExstID = this.franchiseeID
    }
    if (this.type === 'forModule') {
      this.apiName = 'get/fee-module'
      this.label = 'Type of Fee'
      await this.getData(this.apiName)
      this.listName = 'name'
    }
    if (this.type === 'forCategoryList') {
      this.apiName = 'fee-category?isActive=true'
      this.label = 'Select Fee Category'

      await this.getData(this.apiName)

      this.listName = 'name'
    }
  },
  watch: {
    academicYearID: function (value) {
      this.acadmicID = value
    }
  },
  methods: {
    onChangeInfo: function (key) {
      if (key === null || key === undefined || key === '') {
        if (this.type === 'forFranchiseeSelection') {
          this.franchiseeID = ''
        }
        if (this.type === 'forModule') {
          this.moduleID = ''
        }
        if (this.type === 'forCategoryList') {
          this.categoryID = ''
        }
        if (this.type === 'forAcadmicYear' || this.type === 'forCurrentYear') {
          this.academicYearID = ''
        }
        return
      }
      if (this.type === 'forCategoryList') {
        this.categoryID = key
      }
      if (this.type === 'forModule') {
        this.moduleID = key
      }
      if (this.type === 'forFranchiseeSelection') {
        this.franchiseeID = key
      }
      if (this.type === 'forAcadmicYear' || this.type === 'forCurrentYear') {
        this.academicYearID = key
      }
    },
    getData: async function (KeyName) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/${KeyName}`)
        this.loadingComponent.close()
        this.dataInfo = data.rows || data

        this.$emit('toParent', this.dataInfo)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    customFilter (item, queryText) {
      const text = item[this.listName]?.toString().toLowerCase() || ''
      const id = item.id?.toString().toLowerCase() || ''
      const query = queryText.toLowerCase()
      return text.includes(query) || id.includes(query)
    }
  }
}
</script>
